import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Firefox personas - best thing ever",
  "description": "",
  "published": "2009-11-06T00:00:00.000Z",
  "redirect_from": ["/blog/firefox-personas-best-thing-ever/swizec/809"],
  "categories": "Browser, Firefox, Google Chrome, intrigues, Personas, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday I was installing a `}<a parentName="p" {...{
        "href": "http://www.mozilla.com/en-US/firefox/",
        "title": "Firefox"
      }}>{`Firefox`}</a>{` plugin to facilitate webdevelopment because I was shifting my dev environment from the laptop to the freshly karmic kubuntised desktop computer and guess what I stumbled upon.`}</p>
    <p>{`The single best thing ever to make its appearance in the Firefox world!`}</p>
    <p>{`Personas are more than just skins for your firefox, they're downright fucking sexy ... well most of them. Now maybe I'm very far behind the curve here, but the menu entry for Personas does say "New". And to I haven't actually seen them anywhere and well, I really don't know if they're skins at all. My understanding of a Firefox skin is that it can make an ugly GTK+ like application look MacOS-ish.`}</p>
    <p>{`Personas, however, go on top of even that. They're a bit like themes for `}<a parentName="p" {...{
        "href": "http://www.google.com/chrome",
        "title": "Google Chrome"
      }}>{`Google Chrome`}</a>{` except I personally find them even sexier. So if you're using Firefox, go `}<a parentName="p" {...{
        "href": "https://addons.mozilla.org/en-US/firefox/personas/"
      }}>{`fetch something sexy`}</a>{`.`}</p>
    <p>{`Here are some I've tried on for size, but haven't quite decide which is sexiest yet:`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/8ae49c52-9517-4774-a815-ecb0262402b4/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=8ae49c52-9517-4774-a815-ecb0262402b4",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      